import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiPlus, FiEdit2, FiTrash2, FiCalendar, FiUsers, FiMapPin, FiInbox, FiAlertTriangle, FiCopy, FiInfo, FiX, FiCamera } from 'react-icons/fi';
import NexusCoin from '../common/NexusCoin';

// Firebase importok - BŐVÍTVE: doc, deleteDoc, updateDoc, runTransaction
import { db, auth, storage } from '../../firebase';
import { collection, query, where, onSnapshot, doc, deleteDoc, getDocs, writeBatch, runTransaction, updateDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const ClubDashboard = () => {
  const navigate = useNavigate();
  const [competitions, setCompetitions] = useState([]);
  const [closedCompetitions, setClosedCompetitions] = useState([]);
  const [clubData, setClubData] = useState(null); // ÚJ: Klub adatok (kreditekhez)
  const [loading, setLoading] = useState(true);
  const [isUploadingLogo, setIsUploadingLogo] = useState(false); // ÚJ: Feltöltés állapot
  const fileInputRef = React.useRef(null); // ÚJ: File input ref
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState('active');

  // --- MODAL ÁLLAPOTOK ---
  const [showModal, setShowModal] = useState(false);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [showTestPhaseModal, setShowTestPhaseModal] = useState(false);
  const [showOpenRegistrationModal, setShowOpenRegistrationModal] = useState(false); // ÚJ: Nevezés megnyitása modal
  const [compToOpen, setCompToOpen] = useState(null); // ÚJ: Kiválasztott verseny a megnyitáshoz
  const [compToDelete, setCompToDelete] = useState(null);

  // 1. Auth állapot figyelése
  useEffect(() => {
    const unsubscribeAuth = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      if (!currentUser) setLoading(false);
    });
    return () => unsubscribeAuth();
  }, []);

  // 2. Adatok lekérése - INDEX-MENTESÍTVE az azonnali betöltéshez
  useEffect(() => {
    if (!user) return;

    console.log("Lekérés indítása: events, user:", user.uid);
    const q = query(
      collection(db, "events"),
      where("organizerId", "==", user.uid)
    );

    const unsubscribeSnapshot = onSnapshot(q, (querySnapshot) => {
      const comps = [];
      querySnapshot.forEach((doc) => {
        comps.push({ id: doc.id, ...doc.data() });
      });

      console.log("Aktív versenyek betöltve:", comps.length, "db");

      // MANUÁLIS RENDEZÉS
      comps.sort((a, b) => {
        const dateA = a.createdAt?.seconds || 0;
        const dateB = b.createdAt?.seconds || 0;
        return dateB - dateA;
      });

      setCompetitions(comps);
      setLoading(false);
    }, (error) => {
      console.error("Hiba az events lekérésekor:", error);
      setLoading(false);
    });

    return () => unsubscribeSnapshot();
  }, [user]);

  // 3. Lezárt adatok lekérése az events_closed gyűjteményből
  useEffect(() => {
    if (!user) return;

    console.log("Lekérés indítása: events_closed, user:", user.uid);
    const q = query(
      collection(db, "events_closed"),
      where("organizerId", "==", user.uid)
    );

    const unsubscribeClosed = onSnapshot(q, (querySnapshot) => {
      const comps = [];
      querySnapshot.forEach((doc) => {
        comps.push({ id: doc.id, ...doc.data() });
      });

      console.log("Lezárt versenyek betöltve:", comps.length, "db");

      comps.sort((a, b) => {
        const dateA = a.closedAt ? new Date(a.closedAt).getTime() : 0;
        const dateB = b.closedAt ? new Date(b.closedAt).getTime() : 0;
        return dateB - dateA;
      });

      setClosedCompetitions(comps);
    }, (error) => {
      console.error("Hiba az events_closed lekérésekor:", error);
    });

    return () => unsubscribeClosed();
  }, [user]);

  // 4. Klub adatok lekérése (Kreditek)
  useEffect(() => {
    if (!user) return;

    const clubRef = doc(db, "Clubs", user.uid);
    const unsubscribeClub = onSnapshot(clubRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        // Ha nincs kredit mező, alapértelmezettnek tekintjük a 99-et
        if (data.credits === undefined) {
          setClubData({ ...data, credits: 99 });
        } else {
          setClubData(data);
        }
      } else {
        // Ha még nincs dokumentuma a Clubs gyűjteményben
        setClubData({ credits: 99 });
      }
    });

    return () => unsubscribeClub();
  }, [user]);

  // --- LOGÓ FELTÖLTÉS LOGIKA ---
  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || !user) return;

    // Fájltípus ellenőrzés
    if (!file.type.startsWith('image/')) {
      alert("Kérlek, csak képfájlt válassz ki!");
      return;
    }

    setIsUploadingLogo(true);
    try {
      // 1. Feltöltés Firebase Storage-ba
      const logoRef = ref(storage, `club_logos/${user.uid}`);
      await uploadBytes(logoRef, file);

      // 2. Letöltési URL lekérése
      const downloadUrl = await getDownloadURL(logoRef);

      // 3. Adatbázis frissítése
      const clubRef = doc(db, "Clubs", user.uid);
      await updateDoc(clubRef, { logoUrl: downloadUrl });

      console.log("Logó sikeresen feltöltve:", downloadUrl);
    } catch (error) {
      console.error("Hiba a logó feltöltésekor:", error);
      alert("Nem sikerült a logó feltöltése!");
    } finally {
      setIsUploadingLogo(false);
    }
  };

  // --- TÖRLÉS LOGIKA ---
  const openDeleteModal = (comp) => {
    setCompToDelete(comp);
    setShowModal(true);
  };

  const handleFinalDelete = async () => {
    if (!compToDelete) return;

    const collectionName = activeTab === 'active' ? "events" : "events_closed";

    try {
      const batch = writeBatch(db);

      // 1. Nevezők (participants) lekérése és törlése a batch-ben
      const participantsRef = collection(db, collectionName, compToDelete.id, "participants");
      const participantsSnap = await getDocs(participantsRef);
      participantsSnap.forEach((participantDoc) => {
        batch.delete(participantDoc.ref);
      });

      // 2. A verseny fő dokumentumának hozzáadása a törlési listához
      batch.delete(doc(db, collectionName, compToDelete.id));

      // 3. Végrehajtjuk a teljes törlést egyszerre
      await batch.commit();
      
      // Frissítjük a helyi állapotot
      if (activeTab === 'active') {
        setCompetitions(prev => prev.filter(c => c.id !== compToDelete.id));
      } else {
        setClosedCompetitions(prev => prev.filter(c => c.id !== compToDelete.id));
      }
      
      setShowModal(false);
      setCompToDelete(null);
    } catch (error) {
      console.error("Hiba a törlés során:", error);
      alert("A törlés sikertelen!");
    }
  };

  const handleOpenRegistration = async () => {
    if (!compToOpen) return;
    try {
      const docRef = doc(db, "events", compToOpen.id);
      await updateDoc(docRef, { creationType: 'full_event' });
      setShowOpenRegistrationModal(false);
      setCompToOpen(null);
    } catch (error) {
      console.error("Hiba a nevezés megnyitásakor:", error);
      alert("Nem sikerült megnyitni a nevezést!");
    }
  };

  const handleCopyCompetition = (comp) => {
    // Adatok másolása és tisztítása
    const {
      id,
      participantsCount,
      createdAt,
      closedAt,
      status,
      registrationClosed,
      competitionDate,
      startDate,
      endDate,
      registrationDeadline,
      registrationChangeDeadline,
      ...rest
    } = comp;

    const copiedData = {
      ...rest,
      competitionName: `${comp.competitionName || comp.title} (MÁSOLAT)`,
      // Dátumokat ürítjük, hogy a szervezőnek meg kelljen adnia az újat
      competitionDate: '',
      startDate: '',
      endDate: '',
      registrationDeadline: '',
      registrationChangeDeadline: '',
      creationType: 'full_event',
      status: 'Aktív'
    };

    navigate('/verseny-letrehozas', { state: { copiedCompetition: copiedData } });
  };

  // Statisztika számítása
  const totalParticipants = competitions.reduce((sum, comp) => sum + (Number(comp.participantsCount) || 0), 0);

  if (loading && !user) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p style={{ fontSize: '1.2rem', color: '#b30000', fontWeight: 'bold' }}>Betöltés...</p>
      </div>
    );
  }

  // Versenyek szétválogatása
  const activeCompetitions = competitions;
  const pastCompetitions = closedCompetitions;
  
  // Éppen megjelenítendő lista
  const displayCompetitions = activeTab === 'active' ? activeCompetitions : pastCompetitions;

  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
      
      {/* --- EGYEDI TÖRLÉSI ABLAK (MODAL) --- */}
      {showModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <FiAlertTriangle size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Biztosan törölni szeretnéd?</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              Valóban törölni szeretnéd a(z) <br/>
              <strong>{compToDelete?.competitionName || compToDelete?.title}</strong> <br/>
              versenyt? Ez a művelet végleges.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button 
                style={modalCancelButtonStyle} 
                onClick={() => setShowModal(false)}
              >
                Mégse
              </button>
              <button 
                style={modalDeleteButtonStyle} 
                onClick={handleFinalDelete}
              >
                Igen, törlöm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* FEJLÉC */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
        <div>
          <h2 style={{ color: '#b30000', margin: 0 }}>Egyesületi Irányítópult</h2>
          <p style={{ color: '#666', marginTop: '5px' }}>Kezeld a versenyeidet és a nevezéseket.</p>
        </div>

        {/* --- ÚJ: KLUB LOGÓ SZEKCIÓ --- */}
        <div style={{ position: 'relative' }}>
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: '#eee',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            border: '2px solid #fff',
            boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
          }}>
            {clubData?.logoUrl ? (
              <img src={clubData.logoUrl} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            ) : (
              <FiUsers size={40} color="#ccc" />
            )}

            {isUploadingLogo && (
              <div style={{
                position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>
                <div className="upload-spinner" />
              </div>
            )}
          </div>

          <button
            onClick={() => fileInputRef.current?.click()}
            style={{
              position: 'absolute',
              bottom: '-2px',
              right: '-2px',
              backgroundColor: '#b30000',
              color: '#fff',
              border: '2px solid #fff',
              borderRadius: '50%',
              width: '30px',
              height: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
            }}
            title="Logó feltöltése"
          >
            <FiCamera size={16} />
          </button>

          <input
            type="file"
            ref={fileInputRef}
            onChange={handleLogoUpload}
            style={{ display: 'none' }}
            accept="image/*"
          />
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px', marginBottom: '40px' }}>
        <div style={{ ...statCardStyle, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <span style={{ fontSize: '14px', color: '#888' }}>Egyenleged</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: '5px 0' }}>
              <NexusCoin size={32} />
              <h3 style={{ fontSize: '24px', margin: 0, color: '#28a745' }}>
                {clubData?.credits !== undefined ? clubData.credits : '99'} Nexus kredit
              </h3>
            </div>
            <p style={{ fontSize: '12px', color: '#aaa', margin: 0 }}>Minden verseny létrehozása 1 Nexus kredit.</p>
          </div>
          <button
            onClick={() => setShowPurchaseModal(true)}
            style={{
              backgroundColor: '#b30000',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '8px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: '0.2s',
              fontSize: '0.9rem'
            }}
          >
            Nexus kredit feltöltés
          </button>
        </div>
      </div>

      {/* VERSENYEK LISTÁJA - TABS ÉS ÚJ VERSENY GOMB EGY SORBAN */}
      <div style={tabContainerStyle}>
        <div style={tabsWrapperStyle}>
          <div
            style={tabStyle(activeTab === 'active')}
            onClick={() => setActiveTab('active')}
          >
            Aktív versenyeid ({activeCompetitions.length})
          </div>
          <div
            style={tabStyle(activeTab === 'past')}
            onClick={() => setActiveTab('past')}
          >
            Lezárt versenyek ({pastCompetitions.length})
          </div>
        </div>

        <button
          style={createButtonStyle}
          onClick={() => {
            if ((clubData?.credits || 0) < 1) {
              alert("Nincs elég Nexus kredited új verseny létrehozásához!");
              return;
            }
            navigate('/verseny-letrehozas');
          }}
        >
          <FiPlus size={20} />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: '1.1' }}>
            <span>Új verseny létrehozása</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '2px' }}>
               <span style={{ fontSize: '0.7rem', fontStyle: 'italic', fontWeight: 'normal', opacity: 0.9 }}>
                (1 Nexus kredit)
               </span>
            </div>
          </div>
        </button>
      </div>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        {displayCompetitions.length > 0 ? (
          displayCompetitions.map((comp) => (
            <div key={comp.id} style={compCardStyle}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <span style={statusBadgeStyle(comp.status || 'Aktív')}>{comp.status || 'Aktív'}</span>
                  {comp.creationType === 'announcement' && (
                    <span style={{
                      backgroundColor: '#fff5f5', color: '#c53030', padding: '4px 10px',
                      borderRadius: '20px', fontSize: '12px', fontWeight: '900', border: '1px solid #feb2b2'
                    }}>
                      NEVEZÉS ZÁRVA
                    </span>
                  )}
                </div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <FiCopy
                    style={{ cursor: 'pointer', color: '#1877F2' }}
                    title="Másolás új versenynek"
                    onClick={() => handleCopyCompetition(comp)}
                  />
                  {activeTab === 'active' && (
                    <FiEdit2
                      style={{ cursor: 'pointer', color: '#666' }}
                      title="Szerkesztés"
                      onClick={() => navigate(`/verseny-szerkesztes/${comp.id}`)}
                    />
                  )}
                  {activeTab === 'active' && (
                    <FiTrash2
                      style={{ cursor: 'pointer', color: '#b30000' }}
                      title="Törlés"
                      onClick={() => openDeleteModal(comp)}
                    />
                  )}
                </div>
              </div>
              
              <h4 style={{ margin: '0 0 15px 0', fontSize: '18px' }}>{comp.competitionName || comp.title}</h4>
              
              <div style={infoRowStyle}>
                <FiCalendar /> {comp.competitionDate || 'Nincs megadva dátum'}
              </div>
              <div style={infoRowStyle}><FiMapPin /> {comp.location || 'Nincs megadva helyszín'}</div>
              <div style={infoRowStyle}><FiUsers /> {comp.participantsCount || 0} nevező regisztrált</div>
              
              <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
                <button
                  style={manageButtonStyle}
                  onClick={() => navigate(`/versenyiroda/${comp.id}`)}
                >
                  Versenyiroda
                </button>

                {comp.creationType === 'announcement' && (
                  <button
                    style={{
                      ...manageButtonStyle,
                      backgroundColor: '#b30000',
                      color: '#fff',
                      borderColor: '#b30000'
                    }}
                    onClick={() => {
                      setCompToOpen(comp);
                      setShowOpenRegistrationModal(true);
                    }}
                  >
                    Nevezés megnyitása
                  </button>
                )}
              </div>

              {/* VÍZJEL A KÁRTYÁN */}
              {comp.creationType === 'announcement' && (
                <div style={{
                  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%) rotate(-15deg)',
                  fontSize: '2rem', fontWeight: '900', color: 'rgba(197, 48, 48, 0.1)', pointerEvents: 'none',
                  whiteSpace: 'nowrap', textTransform: 'uppercase', zIndex: 0
                }}>
                  Nevezés zárva
                </div>
              )}
            </div>
          ))
        ) : (
          <div style={emptyStateStyle}>
            <FiInbox size={50} style={{ marginBottom: '15px', color: '#ccc' }} />
            <p style={{ margin: 0, fontWeight: 'bold', color: '#888' }}>
              {activeTab === 'active' ? "Még nincsenek aktív versenyeid." : "Még nincsenek lezárt versenyeid."}
            </p>
            {activeTab === 'active' && (
              <p style={{ fontSize: '14px', color: '#aaa' }}>Kattints az "Új verseny létrehozása" gombra!</p>
            )}
          </div>
        )}
      </div>

      <div style={{ height: '80px' }} />

      {/* --- NEXUS KREDIT VÁSÁRLÁS MODAL --- */}
      {showPurchaseModal && (
        <div style={modalOverlayStyle} onClick={() => setShowPurchaseModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '1000px', width: '95%' }} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', borderBottom: '2px solid #b30000', paddingBottom: '15px' }}>
              <h3 style={{ margin: 0, color: '#b30000', fontSize: '1.5rem' }}>Nexus kredit feltöltési csomagok</h3>
              <div
                style={{ cursor: 'pointer', backgroundColor: '#f2f2f2', borderRadius: '50%', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                onClick={() => setShowPurchaseModal(false)}
              >
                <FiX size={20} color="#333" />
              </div>
            </div>

            {/* MIT KAPSZ LISTA */}
            <div style={{ textAlign: 'left', backgroundColor: '#fff5f5', padding: '15px 20px', borderRadius: '12px', border: '1px solid #ffcccc', marginBottom: '20px' }}>
              <h4 style={{ margin: '0 0 10px 0', color: '#b30000', fontSize: '1.05rem' }}>Mit kapsz, ha Nexus kreditet vásárolsz?</h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '8px' }}>
                <div style={featureItemStyle}>✅ <strong>Hivatalos versenyközpont:</strong> A versenyed megjelenik az ArcheryNexus globális naptárában és térképén.</div>
                <div style={featureItemStyle}>✅ <strong>Intelligens nevezési rendszer:</strong> Automatikus korosztály- és kategóriakezelés, létszámstop és határidő figyelés.</div>
                <div style={featureItemStyle}>✅ <strong>Drag & Drop versenyiroda:</strong> Villámgyors csapatbeosztás és helyszíni regisztráció kezelése.</div>
                <div style={featureItemStyle}>✅ <strong>Profi dokumentumok:</strong> Automatikusan generált, nyomtatható rajtlisták és QR-kódos névcímkék.</div>
                <div style={featureItemStyle}>✅ <strong>LIVE eredménykövetés:</strong> Azonnali rangsorszámítás az appban és a weben.</div>
                <div style={featureItemStyle}>✅ <strong>Örök kreditek:</strong> A megvásárolt Nexus kreditek soha nem járnak le, akár a következő szezonban is felhasználhatod őket.</div>
                <div style={featureItemStyle}>✅ <strong>Offline versenyiroda:</strong> (Fejlesztés alatt) Stabil működés térerő nélküli pályákon is, és a verseny lebonyolitását követően automatikus felhő-szinkronizációval.</div>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px', padding: '10px' }}>
              {[
                { amount: 1, price: '15.000', per: '15.000' },
                { amount: 3, price: '37.500', per: '12.500', savings: '16%' },
                { amount: 5, price: '50.000', per: '10.000', savings: '33%' },
                { amount: 10, price: '80.000', per: '8.000', savings: '46%' }
              ].map((pkg, idx) => (
                <div key={idx} style={{
                  backgroundColor: '#f8f9fa',
                  borderRadius: '15px',
                  padding: '15px 20px',
                  textAlign: 'center',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
                  border: `3px solid ${pkg.amount === 1 ? '#1976D2' : (pkg.amount === 3 ? '#F44336' : '#FFD700')}`,
                  position: 'relative'
                }}>
                  {pkg.savings && (
                    <div style={{
                      position: 'absolute', top: '-12px', right: '10px',
                      backgroundColor: '#28a745', color: '#fff',
                      padding: '4px 10px', borderRadius: '10px', fontSize: '0.75rem', fontWeight: 'bold'
                    }}>
                      -{pkg.savings}
                    </div>
                  )}
                  <div style={{ marginBottom: '15px' }}>
                    <NexusCoin size={48} />
                  </div>
                  <h4 style={{ margin: '0 0 10px 0', fontSize: '1.3rem', color: '#b30000' }}>{pkg.amount} Nexus kredit</h4>
                  {/* ÁRAK KITAKARÁSA FEKETE CSIKKAL */}
                  <div style={{ backgroundColor: '#000', height: '2.5rem', margin: '10px auto', width: '80%', borderRadius: '4px' }}></div>
                  <div style={{ backgroundColor: '#000', height: '1.2rem', margin: '10px auto', width: '60%', borderRadius: '4px' }}></div>
                  <button
                    onClick={() => setShowTestPhaseModal(true)}
                    style={{
                      width: '100%', padding: '12px', borderRadius: '8px', border: '1.5px solid #b30000',
                      backgroundColor: 'transparent', color: '#b30000', fontWeight: 'bold', cursor: 'pointer',
                      transition: 'all 0.2s'
                    }}
                    onMouseEnter={(e) => { e.target.style.backgroundColor = '#b30000'; e.target.style.color = '#fff'; }}
                    onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; e.target.style.color = '#b30000'; }}
                  >
                    Vásárlás
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* --- TESZTFÁZIS TÁJÉKOZTATÓ MODAL --- */}
      {showTestPhaseModal && (
        <div style={modalOverlayStyle} onClick={() => setShowTestPhaseModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '450px' }} onClick={(e) => e.stopPropagation()}>
            <FiInfo size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Információ</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              Jelenleg az ArcheryNexus <strong>tesztfázisban</strong> van és ingyenesen elérhető. <br/><br/>
              Ebben az időszakban nem tudsz kreditet vásárolni, de minden funkciót szabadon használhatsz!
            </p>
            <button
              style={{ ...modalDeleteButtonStyle, backgroundColor: '#b30000', width: '100%' }}
              onClick={() => setShowTestPhaseModal(false)}
            >
              Értem
            </button>
          </div>
        </div>
      )}

      {/* --- NEVEZÉS MEGNYITÁSA CONFIRM MODAL --- */}
      {showOpenRegistrationModal && (
        <div style={modalOverlayStyle} onClick={() => setShowOpenRegistrationModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '450px' }} onClick={(e) => e.stopPropagation()}>
            <FiInfo size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Nevezés megnyitása</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              Biztosan meg akarod nyitni a nevezést a következő versenyhez? <br/>
              <strong>{compToOpen?.competitionName}</strong> <br/><br/>
              Ezután az íjászok azonnal jelentkezhetnek az appban és a weben.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button
                style={modalCancelButtonStyle}
                onClick={() => setShowOpenRegistrationModal(false)}
              >
                Mégse
              </button>
              <button
                style={{ ...modalDeleteButtonStyle, backgroundColor: '#28a745' }}
                onClick={handleOpenRegistration}
              >
                Igen, megnyitom
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .upload-spinner {
          width: 24px;
          height: 24px;
          border: 3px solid #f3f3f3;
          border-top: 3px solid #b30000;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

// --- STÍLUSOK (Visszaállítva multiline formátumba) ---

const tabContainerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  marginBottom: '25px',
  borderBottom: '1px solid #eee'
};

const tabsWrapperStyle = {
  display: 'flex',
  gap: '30px'
};

const tabStyle = (isActive) => ({
  padding: '10px 5px',
  fontSize: '18px',
  fontWeight: 'bold',
  cursor: 'pointer',
  color: isActive ? '#b30000' : '#888',
  borderBottom: isActive ? '3px solid #b30000' : '3px solid transparent',
  transition: '0.3s ease'
});

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
  backdropFilter: 'blur(3px)'
};

const modalContentStyle = {
  backgroundColor: 'white',
  padding: '30px',
  borderRadius: '15px',
  textAlign: 'center',
  maxWidth: '400px',
  width: '90%',
  boxShadow: '0 15px 35px rgba(0,0,0,0.3)'
};

const modalDeleteButtonStyle = {
  backgroundColor: '#b30000',
  color: 'white',
  border: 'none',
  padding: '12px 24px',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const modalCancelButtonStyle = {
  backgroundColor: '#eee',
  color: '#333',
  border: 'none',
  padding: '12px 24px',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const createButtonStyle = {
  backgroundColor: '#b30000',
  color: 'white',
  border: 'none',
  padding: '6px 15px',
  borderRadius: '10px',
  fontWeight: 'bold',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '15px',
  transition: '0.2s',
  marginBottom: '5px'
};

const statCardStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
  borderLeft: '4px solid #b30000'
};

const compCardStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '12px',
  boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
  position: 'relative'
};

const emptyStateStyle = {
  gridColumn: '1 / -1',
  textAlign: 'center',
  padding: '60px 20px',
  backgroundColor: '#fdfdfd',
  borderRadius: '12px',
  border: '2px dashed #eee',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
};

const statusBadgeStyle = (status) => ({
  backgroundColor: status === 'Aktív' ? '#e6fffa' : '#fffaf0',
  color: status === 'Aktív' ? '#2c7a7b' : '#b7791f',
  padding: '4px 10px',
  borderRadius: '20px',
  fontSize: '12px',
  fontWeight: 'bold'
});

const infoRowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '14px',
  color: '#555',
  marginBottom: '8px'
};

const manageButtonStyle = {
  width: '100%',
  marginTop: '15px',
  padding: '10px',
  backgroundColor: 'transparent',
  border: '1.5px solid #b30000',
  color: '#b30000',
  borderRadius: '6px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const featureItemStyle = {
  fontSize: '0.85rem',
  color: '#444',
  lineHeight: '1.4',
  marginTop: '5px'
};

export default ClubDashboard;


